// extracted by mini-css-extract-plugin
module.exports = {"contactUsPage":"styles_contactUsPage__Pxd2q","contentHolder":"styles_contentHolder__hH8FO","contactText":"styles_contactText__cE9Gp"};